import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/HsmTemplate/Fetch'
import ActionDelete from '../../store/action/HsmTemplate/Delete'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetTemplate from '../../store/action/Template/FetchAll'
import ActionView from '../../store/action/HsmTemplate/View'
import ActionStatus from '../../store/action/HsmTemplate/Status'
import CustomGrid from '../../infra/components/grid/custom-grid-without-search'
import '../../source/util.css'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import { ClientId, DivisionId, SenderId, PrevilageId } from '../../helper/HelperAuth'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import ActionFindByGroupId from '../../store/action/Previlage/FindByGroupId'
import Swal from "sweetalert2";

class Page extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'HSM Template',
      form: fromJS({
        show: false,
        actionType: '',
        item: fromJS({}),
      }),
      isadmin: false,
      formSearch: fromJS({
        search: '',
      }),
      search: fromJS([
        {
          widthClass: 'col-sm-12',
          id: 'search',
          placeholder: 'Search',
          label: '',
          value: '',
        },
      ]),
      searchForm: fromJS({
        'client-id': '',
        'template-id': '',
        'template-status': -1,
        'template-type': '',
        'media-type': '',
        'template-name': '',
      }),
      listTemplateStatus: fromJS([
        { value: 0, label: 'New' },
        { value: 1, label: 'Approved' },
        { value: 2, label: 'Rejected' },
      ]),

      listTemplateType: fromJS([
        { value: 'hsm', label: 'Text' },
        { value: 'template', label: 'Media' },
      ]),

      listTemplateHSM: fromJS([
        { value: 'image', label: 'Image' },
        { value: 'document', label: 'Document' },
        { value: 'video', label: 'Video' },
      ]),

      listTemplateCategory: fromJS([
        { "template-category-id": 1, "template-category-name": "Authentication" },
        { "template-category-id": 2, "template-category-name": "Marketing" },
        { "template-category-id": 3, "template-category-name": "Utility" },
        // { "template-category-id": 4, "template-category-name": "Service" },
      ]),

      columns: [
        { className: 'col-md-1', cfield: 'counter', caption: 'No' },
        {
          className: '',
          field: 'namespace',
          caption: 'Namespace',
        },
        { className: '', field: 'template-id', caption: ' ID' },
        {
          className: '',
          field: 'template-name',
          caption: 'Name',
        },
        { className: '', field: 'type', caption: 'Type' },
        { className: '', field: 'status-text', caption: 'Status' },
        {
          field: 'raw-message',
          caption: 'Message',
        },
        {
          className: 'col-md-1',
          cfield: 'action',
          caption: 'Actions',
        },
        {
          className: 'col-md-1',
          cfield: 'action',
          caption: 'Update Status',
          allowView: false,
          allowEdit: false,
          allowDelete: false,
          custom: fromJS([
            {
              id: 'Approve',
              icon: 'check',
              label: 'Approve',
              className: 'btn-trans btn-sm waves-effect text-success ',
            },
            {
              id: 'Reject',
              icon: 'close',
              label: 'Reject',
              className: 'btn-trans btn-sm waves-effect text-danger',
            },
          ]),
        },
      ],

      columnsView: [
        { className: 'col-md-1', cfield: 'counter', caption: 'No' },
        {
          className: '',
          field: 'namespace',
          caption: 'Namespace',
        },
        { className: '', field: 'template-id', caption: ' ID' },
        {
          className: '',
          field: 'template-name',
          caption: 'Name',
        },
        { className: '', field: 'type', caption: 'Type' },
        { className: '', field: 'status-text', caption: 'Status' },
        {
          field: 'raw-message',
          caption: 'Message',
        },
      ],

      errors: fromJS({}),
      actionId: '',
    }

    this.showContent = this.showContent.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleNew = this.handleNew.bind(this)
    this.handleFind = this.handleFind.bind(this)
    this.handleViewClicked = this.handleViewClicked.bind(this)
    this.handleEditClicked = this.handleEditClicked.bind(this)
    this.handleRemoveClicked = this.handleRemoveClicked.bind(this)
    this.handleCancelForm = this.handleCancelForm.bind(this)
    this.handlePageChanged = this.handlePageChanged.bind(this)
    this.handleCustomAction = this.handleCustomAction.bind(this)
    this.changeAction()
  }
  async handleCustomAction(id, row) {
    var template_id = row.get('template-id')
    switch (id) {
      case 'Approve':
        var response = await this.props.actionStatus(template_id, 1)
        if (response.ok) {
          toast.success('Update Status Success!', toast.POSITION.BOTTOM_RIGHT)
          this.handleFindSearch(1)
        } else {
          //toast.error('Process Failed!', toast.POSITION.BOTTOM_RIGHT)
        }
        break
      case 'Reject':
        var response = await this.props.actionStatus(template_id, 2)
        if (response.ok) {
          toast.success('Update Status Success!', toast.POSITION.BOTTOM_RIGHT)
          this.handleFindSearch(1)
        } else {
          //toast.error('Process Failed!', toast.POSITION.BOTTOM_RIGHT)
        }
        break

      default:
    }
  }
  handleOnBindCustomAction(actionId, row) {
    if (row.get('status') === 0) {
      return true
    }
    return false
  }
  async componentDidMount() {
    this.props.actionGetAllClient()
    this.props.actionGetTemplate()
    var isAdmin = await this.props.actionFindByGroupId()
    this.setState({ isadmin: isAdmin })
    var action = await this.props.actionGetAccessModuleIdAction(
      'Request Submit Template'
    )
    this.changeAction()
  }

  changeAction() {
    var varActionId = ''
    var dataAkses = null
    dataAkses = this.props.accessmoduleaction
    if (dataAkses) {
      varActionId = dataAkses.get('action-id')
      this.setState({ actionId: varActionId })
    }
  }

  handleSearch(obj) {
    this.setState({ formSearch: obj })
    this.refreshGrid(1, obj)
  }

  handleCancelForm(refresh) {
    if (refresh) {
      this.handleFindSearch(1)
    }
    this.setState({
      form: fromJS({
        show: false,
        actionType: '',
        item: fromJS({}),
      }),
    })
  }

  handleNew() {
    this.setState({
      form: fromJS({
        show: true,
        actionType: IsCreate,
        item: fromJS({}),
      }),
    })
  }

  async handleViewClicked(value) {
    var detail = await this.props.actionView(value.get('template-id'))
    this.setState({
      form: fromJS({
        show: true,
        actionType: IsView,
        item: detail,
      }),
    })
  }

  async handleEditClicked(value) {
    var detail = await this.props.actionView(value.get('template-id'))
    this.setState({
      form: fromJS({
        show: true,
        actionType: IsEdit,
        item: detail,
      }),
    })
  }

  handlePageChanged = (value) => {
    const { formSearch } = this.state
    this.refreshGrid(value, formSearch)
  }

  refreshGrid(page, search) {
    this.handleFindSearch(page)
  }

  async handleRemoveClicked(value) {
    var body = {
      data: {
        'template-id': value.get('template-id'),
      },
    }
    var temp = await this.props.actionDelete(body)
    if (temp.ok) {
      toast.success(
        'Delete ' + value.get('template-name') + ' Success!',
        toast.POSITION.BOTTOM_RIGHT
      );
      Swal.fire("Deleted!", "Data has been deleted.", "success");
      this.handleFindSearch(1)
    } else {
      toast.error(
        'Delete ' + value.get('template-name') + ' Failed!',
        toast.POSITION.BOTTOM_RIGHT
      );
      Swal.fire("Failed!", "Failed to delete data.", "error");
    }
  }

  async updateStatus(id, status) {
    if (id === 'CheckStatus') {
      var response = await this.props.actionStatus(id, status)
      if (response.ok) {
        toast.success('Update Status Success!', toast.POSITION.BOTTOM_RIGHT)
        this.handleFindSearch(1)
      } else {
        //toast.error('Process Failed!', toast.POSITION.BOTTOM_RIGHT)
      }
    }
  }

  handleChange(field, value, label) {
    var formVal = this.state.searchForm
    formVal = formVal.set(field, value)

    this.setState({ searchForm: formVal })
  }

  handleFind() {
    this.handleFindSearch(1)
  }

  handleFindSearch(page) {
    const { searchForm } = this.state
    let template_id =
      searchForm.get('template-id') == '' ? 0 : searchForm.get('template-id')
    let client_id = searchForm.get('client-id')
    let template_type = searchForm.get('template-type')
    let media_type = searchForm.get('media-type')
    let template_name = searchForm.get('template-name')
    let senderIdRest = ''
    var varActionId = this.state.actionId
    var isAdmin = this.state.isadmin

    if (varActionId == 5) {
      senderIdRest = SenderId
    }

    if (media_type === null) media_type = ''
    if (template_type === null) template_type = ''

    if (PrevilageId != 1 && isAdmin == false && client_id == '')
      client_id = ClientId
    if ((PrevilageId == 1 || isAdmin == true) && client_id == '') client_id = 0

    let bodyFInd = {
      'client-id': client_id,
      'sender-id': senderIdRest,
      'template-id': template_id,
      'template-type': template_type,
      'media-type': media_type,
      'template-name': template_name,
      'template-status': searchForm.get('template-status'),
    }
    //debugger
    this.props.actionGet(page, bodyFInd)
  }

  showContent() {
    var { form, listTemplateCategory } = this.state;

    if (form.get('show')) {
      return (
        <Form
          actionType={form.get('actionType')}
          item={form.get('item')}
          listTemplateCategory={listTemplateCategory}
          handleCancelForm={this.handleCancelForm}
          handleSubmitOnForm={this.handleSubmitOnForm}
        ></Form>
      )
    } else {
      const items = this.props.hsmtemplate
        ? fromJS(this.props.hsmtemplate)
        : fromJS({});
      let col = this.state.columnsView
      if (PrevilageId == 1 || this.state.isadmin == true)
        col = this.state.columns
      return (
        <CustomGrid
          title="HSM Template"
          columns={col}
          items={items}
          headerAction={this.state.headerAction}
          search={this.state.search}
          handleViewClicked={this.handleViewClicked}
          handleEditClicked={this.handleEditClicked}
          handleRemoveClicked={this.handleRemoveClicked}
          handlePageChanged={this.handlePageChanged}
          handleOnBindCustomAction={this.handleOnBindCustomAction}
          handleCustomAction={this.handleCustomAction}
        ></CustomGrid>
      )
    }
  }

  render() {
    const { form, searchForm, errors } = this.state
    let hideButton = 'col-sm-2 hide'
    if (PrevilageId == 1 || this.state.isadmin == true) {
      hideButton = 'col-sm-2'
    }
    const title = form.get('show')
      ? form.get('actionType') === IsCreate
        ? 'Add HSM Template'
        : form.get('actionType') === IsView
        ? 'Detail HSM Template'
        : 'Edit HSM Template'
      : 'HSM Template'
    const classHide = !form.get('show') ? 'card' : 'card hidden'
    return (
      <div className="clearfix">
        <div className="card-noborder">
          <h4>{title}</h4>
        </div>
        <div className={classHide}>
          <div className="body">
            <div className="row">
              <div className="col-sm-6">
                <ComboboxInput
                  field="client-id"
                  value={searchForm.get('client-id')}
                  options={fromJS({
                    source: this.props.clientall,
                    value: 'client-id',
                    label: 'client-name',
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Client"
                />
              </div>
              <div className="col-sm-6">
                <ComboboxInput
                  field="template-status"
                  value={searchForm.get('template-status')}
                  options={fromJS({
                    source: this.state.listTemplateStatus,
                    value: 'value',
                    label: 'label',
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Template Status"
                />
              </div>
              <div className="col-sm-6">
                <ComboboxInput
                  field="template-type"
                  value={searchForm.get('template-type')}
                  options={fromJS({
                    source: this.state.listTemplateType,
                    value: 'value',
                    label: 'label',
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Template Type"
                />
              </div>
              <div className="col-sm-6">
                <ComboboxInput
                  field="media-type"
                  value={searchForm.get('media-type')}
                  options={fromJS({
                    source: this.state.listTemplateHSM,
                    value: 'value',
                    label: 'label',
                  })}
                  onChange={(field, value, label) =>
                    this.handleChange(field, value, label)
                  }
                  placeholder="Media Type"
                />
              </div>
              <div className="col-sm-6">
                <TextInputField
                  className="form-control"
                  field="template-name"
                  value={searchForm.get('template-name')}
                  onChange={(field, value) =>
                    this.handleChange(field, value, '')
                  }
                  placeholder="template-name"
                  disabled={false}
                  hasError={errors.has('HSM Template name')}
                />
              </div>
            </div>
            <div className="row no-margin-bottom">
              <div className="col-sm-2">
                <button
                  type="button"
                  className="btn btn-wide btn-success"
                  onClick={this.handleFind}
                >
                  Search
                </button>
              </div>
              <div className="col-sm-1"></div>
              <div className={hideButton}>
                <button
                  type="button"
                  className="btn btn-wide btn-success content-add"
                  onClick={this.handleNew}
                >
                  <i className="material-icons">{'add'}</i>
                  {'Add'}
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.showContent()}
      </div>
    )
  }
}


export default connect(
    (state) => {
        return {
            hsmtemplate: state.user.hsmtemplate,
            clientall: state.user.clientall,
            templateall: state.user.templateall,
            accessmoduleaction: state.user.accessmoduleaction,
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionView: ActionView,
        actionStatus: ActionStatus,
        actionGetAllClient: ActionGetAllClient,
        actionGetTemplate: ActionGetTemplate,
        actionGetAccessModuleIdAction: ActionGetAccessModuleIdAction,
        actionFindByGroupId:ActionFindByGroupId
    }, dispatch),
)(Page);